<template>
  <a-spin tip="Your document is being processed, do not leave this page!" :spinning="pageLoading">
    <a-card class="m-display-flex flex-column nowrap">
      <span slot="title">Create {{ collectData.information ? collectData.information.jenis_spt : 'SPT' }}</span>
      <div slot="extra">
        <a-tag v-if="tipeTrans">{{ tipeTrans }}</a-tag>
      </div>
      <a-steps :current="current" status="process">
        <a-step title="Information" />
        <a-step title="Compensation" v-if="lbl_next_btn == 'insufficient payment'" />
        <!-- <a-step title="Supporting Document" /> -->
      </a-steps>
      <div class="steps-content flex-1">
        <keep-alive>
          <component class="flex-1" :is="steps[current].content" :ref="stepRef" v-bind="stepProps"></component>
        </keep-alive>
      </div>
      <template slot="actions">
        <!-- class="ant-card-actions" -->
        <div class="steps-action">
          <a-button v-if="current < steps.length - 1 && steps.length > 1 && lbl_next_btn != 'overpayment'" type="primary"
            @click="next" :disabled="disabledNextButton">Next</a-button>
          <a-button-group>
            <a-button :loading="btnLoading && btnLoading2"
              v-if="current == steps.length - 1 || lbl_next_btn == 'overpayment'" type="default" @click="savedraft"
              :disabled="disbuttonsts">Save Draft</a-button>
            <a-button :loading="btnLoading && !btnLoading2"
              v-if="current == steps.length - 1 || lbl_next_btn == 'overpayment'" type="primary" @click="validate"
              :disabled="disbuttonsts">Submit</a-button>
          </a-button-group>
          <a-button v-if="current > 0" @click="prev">Previous</a-button>
        </div>
      </template>
    </a-card>
  </a-spin>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import Informasi from "./steps/Informasi.vue";
import Compensation from "./steps/Compensation.vue";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import GlobalMethod from "@/mixins/GlobalMethod";
import shortingArray from "@/mixins/MultishortArray";
//import SupportingDocument from "./steps/SupportingDocument.vue";

export default {
  name: "SPTCreate",
  props: { id: String },
  mixins: [CurrencyFormat, shortingArray, GlobalMethod],
  components: {
    Informasi,
    Compensation,
    //SupportingDocument,
  },
  data() {
    return {
      mode: "Create",
      current: 0,
      steps: [
        {
          title: "Informasi",
          content: "Informasi",
        },
        {
          title: "Compensation",
          content: "Compensation",
        },
        // {
        //   title: "SupportingDocument",
        //   content: "SupportingDocument",
        // },
      ],
      disabledNextButton: false,
      collectData: {
        information: null,
        list_tax_detail: null,
        extra: null,
        pembetulan: null,
        status_besar: "",
      },
      btnLoading: false,
      btnLoading2: false,
      pageLoading: false,
      lbl_next_btn: '',
      disbuttonsts: false,
      note: "",
      noteOri: "",
    };
  },
  computed: {
    ...mapGetters(["getAuth"]),
    stepProps: function () {
      if (this.mode === "Edit") {
        if (this.steps[this.current].content === "Informasi") {
          return {
            collectData: this.collectData,
            id: this.id,
            tipe: this.tipeTrans,
            catatan: this.note,
            catatanOri: this.noteOri,
          };
        } else
        // if (this.steps[this.current].content === "Compensation")
        {
          return {
            collectData: this.collectData,
            id: this.id,
            catatan: this.note,
            catatanOri: this.noteOri,
          };
        }
        // else {
        //   return {
        //     collectData: this.collectData,
        //     id: this.id,
        //     lbl_next_btn: this.lbl_next_btn,
        //   };
        //}
      } else {
        if (this.steps[this.current].content === "Informasi") {
          return {
            collectData: this.collectData,
            catatan: this.note,
            catatanOri: this.noteOri,
          };
        } else
        // if (this.steps[this.current].content === "Compensation")
        {
          return {
            collectData: this.collectData,
            catatan: this.note,
            catatanOri: this.noteOri,
          };
        }
        // else {
        //   return {
        //     collectData: this.collectData,
        //     lbl_next_btn: this.lbl_next_btn,
        //   };
        // }
      }
    },
    stepRef: function () {
      if (this.steps[this.current].content === "Informasi") {
        return "refInformasi";
      } else
      // if (this.steps[this.current].content === "Compensation")
      {
        return "refCompensation";
      }
      // else {
      //   return "refSupportingDocument";
      // }
    },
    tipeTrans() {
      //this.tipe ? CryptoJS.AES.decrypt(this.tipe, "IAO-key").toString(CryptoJS.enc.Utf8) : 
      return this.collectData.pembetulan ? this.collectData.pembetulan.tipe_pembetulan_label :
        (this.tipe ? this.tipe : null)
    }
  },
  created() {
    if (this.id) {
      this.mode = "Edit";
      this.pageLoading = true;
    }
  },
  methods: {
    next() {
      if (this.steps[this.current].content === "Informasi") {
        this.$refs.refInformasi.handleRef();
      } else if (this.steps[this.current].content === "Compensation") {
        this.$refs.refCompensation.handleRef();
      } else {
        this.$refs.refInformasi.handleRefSubmit();
      }
    },
    prev() {
      this.current--;
    },
    validate() {
      const that = this;
      this.$confirm({
        title: "Are you sure to submit this data?",
        content: "",
        okText: "Yes",
        cancelText: "No",
        onOk() {
          // if (that.lbl_next_btn == 'insufficient payment') {
          // Event.$emit("sptData", {
          //   note: "",
          //   is_draft: 0,
          // });
          // } else {
          let a = that.steps[that.current].content;
          if (a === "Informasi") {
            that.$refs.refInformasi.handleRefSubmit();
          } else {
            that.$refs.refCompensation.handleRefSubmit();
          }
          // }
        },
        onCancel() { },
      });
    },
    savedraft() {
      let a = this.steps[this.current].content;
      if (a === "Informasi") {
        this.$refs.refInformasi.handleRefDraft();
      } else {
        this.$refs.refCompensation.handleRefDraft();
      }
    },
    valueFromChild(value) {
      if (this.steps[this.current].content === "Informasi") {
        if (this.mode === "Create") {
          if (value.from == "next") {
            this.collectData.information = JSON.parse(
              JSON.stringify(value.information)
            );
            this.collectData.list_tax_detail = JSON.parse(
              JSON.stringify(value.list_tax_detail)
            );
            if (value.list_pbk) {
              this.collectData.list_pbk = JSON.parse(
                JSON.stringify(value.list_pbk)
              );
            } else {
              this.collectData.list_pbk = null
            }
            this.current++;
          } else {
            this.collectData.information = JSON.parse(
              JSON.stringify(value.information)
            );
            this.collectData.list_tax_detail = JSON.parse(
              JSON.stringify(value.list_tax_detail)
            );
            if (value.list_pbk) {
              this.collectData.list_pbk = JSON.parse(
                JSON.stringify(value.list_pbk)
              );
            } else {
              this.collectData.list_pbk = null
            }
            if (value.pembetulan)
              this.collectData.pembetulan = JSON.parse(JSON.stringify(value.pembetulan));

            this.collectData.status_besar = value.status_besar;
            this.lbl_next_btn = (value.total_nilai_label == 'Kurang Bayar' ? 'insufficient payment' : 'overpayment');
          }

          if (value.extra) {
            this.collectData.extra = value.extra;
            this.note = value.extra.note?value.extra.note:"";
          }

          if (value.from == "submit") {
            this.submit();
          }
        } else {
          if (value.from == "next") {
            this.current++;
            this.collectData.information = JSON.parse(
              JSON.stringify(value.information)
            );
            this.collectData.list_tax_detail = JSON.parse(
              JSON.stringify(value.list_tax_detail)
            );
            if (value.list_pbk) {
              this.collectData.list_pbk = JSON.parse(
                JSON.stringify(value.list_pbk)
              );
            } else {
              this.collectData.list_pbk = null
            }
            this.collectData.extra = value.extra;
          } else {
            this.collectData.information = JSON.parse(
              JSON.stringify(value.information)
            );
            this.collectData.list_tax_detail = JSON.parse(
              JSON.stringify(value.list_tax_detail)
            );

            if (value.list_pbk) {
              this.collectData.list_pbk = JSON.parse(
                JSON.stringify(value.list_pbk)
              );
            } else {
              this.collectData.list_pbk = null
            }

            if (value.source)
              this.collectData.source = JSON.parse(
                JSON.stringify(value.source)
              );

            if (value.pembetulan)
              this.collectData.pembetulan = JSON.parse(JSON.stringify(value.pembetulan));

            this.collectData.status_besar = value.status_besar;
            this.lbl_next_btn = (value.total_nilai_label == 'Kurang Bayar' ? 'insufficient payment' : 'overpayment');
          }

          if (value.extra) {
            this.collectData.extra = value.extra;
            this.note = value.extra.note?value.extra.note:"";
          }

          if (value.from == "submit") {
            this.submit();
          }
        }

        if (value.from == "back") {
          this.current--;
        }
      } else if (this.steps[this.current].content === "Compensation") {
        if (value.from == "back") {
          this.current--;
        } else if (value.from == "submit") {
          this.collectData.extra = value.extra;
          this.submit();
        } else {
          this.current++;
        }
      }

      if (value.noteOri) {
        this.noteOri = value.noteOri;
      }
    },
    submit() {
      this.btnLoading = true;
      this.btnLoading2 = this.collectData.extra.is_draft == 1 ? true : false;
      let data = new FormData();
      data.append("spt_id", this.collectData.information.spt_id);
      data.append("note", this.collectData.extra.note);
      data.append("is_draft", this.collectData.extra.is_draft);

      this.asyncAxiosPost("spt", "formdata", this.getAuth, data)
        .then((response) => {
          this.btnLoading = false;
          this.btnLoading2 = false;
          if (response.status && response.status == true) {
            this.displayMessageValue("success-other", response.message);
            this.$router.push({
              name: "SPTManifest",
              params: { id: response.id, tipe: this.collectData.information.jenis_spt_value },
            });
          } else {
            let responses = Object.assign({}, response);
            this.displayMessageValue("error-other", responses);
          }
        })
        .catch(() => {
          this.btnLoading = false;
          this.btnLoading2 = false;
          // let responses = Object.assign({}, err.response);
          // console.log(responses)
          // this.displayMessageValue("error-other", responses.message);
        });
    },
    disableNext(val) {
      this.disabledNextButton = val;
    },
    pgloading(val) {
      this.pageLoading = val;
    },
    // triggerNextProcess(val) {
    //   this.lbl_next_btn = val.text;
    // },
    disbutton(val) {
      this.disbuttonsts = val;
    }
  },
  mounted() {
    Event.$on("sptData", this.valueFromChild);
    Event.$on("listWO", this.getListWO);
    Event.$on("updateList", this.getUpdatePekerjaan);
    Event.$on("confirmMessageReturn", this.submit);
    Event.$on("disableNext", this.disableNext);
    Event.$on("pgloading", this.pgloading);
    Event.$on("toPrevious", this.prev);
    //Event.$on("triggerNext", this.triggerNextProcess);
    Event.$on("triggerdisbutton", this.disbutton);

    if (this.$route.params && this.$route.params.information) {
      Event.$emit("sptData", {
        from: "axios",
        information: this.$route.params.information,
        list_tax_detail: this.$route.params.list_tax_detail,
        list_pbk: this.$route.params.list_pbk,
        source: this.$route.params.source,
        pembetulan: {
          tipe_pembetulan: null,
          tipe_pembetulan_label: null
        },
        status_besar: 'On Process',
        total_nilai_label: this.$route.params.information.total_nilai_label
      });
    }
  },
  beforeDestroy() {
    Event.$off("sptData", this.valueFromChild);
    Event.$off("listWO", this.getListWO);
    Event.$off("updateList", this.getUpdatePekerjaan);
    Event.$off("confirmMessageReturn", this.submit);
    Event.$off("disableNext", this.disableNext);
    Event.$off("pgloading", this.pgloading);
    Event.$off("toPrevious", this.prev);
    //Event.$off("triggerNext", this.triggerNextProcess);
    Event.$off("triggerdisbutton", this.disbutton);
  },
};
</script>

<style></style>